// extracted by mini-css-extract-plugin
export default {"pill":"styles_pill__QR0Sg","pill--success":"styles_pill--success__EgrSa","pill--notify":"styles_pill--notify__qAwZh","pill--error":"styles_pill--error__tOsah"};